import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  const typeLabel = item.type === "movie" ? "电影" : "剧集";
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}海报`}
          title={`${item.title} - ${item.genres.join(" ")}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-semibold bg-primary-500/90 text-background-50 backdrop-blur-sm">
          {typeLabel}
        </span>
        <span className="absolute top-2 right-2 inline-flex items-center gap-0.5 px-2 py-0.5 rounded-md text-[11px] font-bold bg-accent-500 text-foreground-950">
          <i className="ri-star-fill text-[10px]" />
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {item.year} · {item.region} · {item.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}